<template>
  <div :id="id" :style="chartStyle"></div>
</template>
<script>
import Chart from './mixins/Chart';
export default {
  mixins: [Chart],
  props: {
    // 提示框
    tooltipData: {
      type: Object,
      default() {
        return {
          formatter: '{b}: {c} ({d}%)',
        };
      },
    },
    // 是否是环形
    isRing: {
      type: Boolean,
      default: false,
    },
    // 是否显示延长线标签
    hasPieLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isMobile: false
    };
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    init() {
      this.chartsDom = this.$echarts.init(document.getElementById(this.id));
      // 每次数据更新都清空一次实例，以便页面重新渲染，否则更新数据没有变化，页面看起来像没动
      document.getElementById(this.id).removeAttribute('_echarts_instance_');
      this.option = this.isMobile ? {
        title: {
          subtextStyle: {
            color: 'white',
            fontSize: 24,
            lineHeight: 32,
            fontWeight: 500,
          },
          textStyle: {
            color: 'white',
            fontSize: 12,
            lineHeight: 16,
          },
          left: 'center',
          top: 75,
          itemGap: 2,
          ...this.titleData,
        },
        grid: {
          ...this.gridData,
        },
        tooltip: {
          ...this.tooltipConfig,
          ...this.tooltipData,
        },
        legend: this.legendData.map((v) => ({
          top: 0,
          left: 70,
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            fontSize: 12,
            color: 'white',
          },
          ...v,
        })),
        color: this.colors,
        series: [],
      } : {
        title: {
          subtextStyle: {
            color: 'white',
            fontSize: 24,
            lineHeight: 32,
            fontWeight: 500,
          },
          textStyle: {
            color: 'white',
            fontSize: 12,
            lineHeight: 16,
          },
          left: 'center',
          top: 75,
          itemGap: 2,
          ...this.titleData,
        },
        grid: {
          ...this.gridData,
        },
        tooltip: {
          ...this.tooltipConfig,
          ...this.tooltipData,
        },
        legend: this.legendData.map((v) => ({
          top: 0,
          left: 70,
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 12,
          textStyle: {
            fontSize: 12,
            color: 'white',
          },
          ...v,
        })),
        color: this.colors,
        series: [],
      };
      // 处理 series
      this.seriesData.forEach((item) => {
        const { data = [] } = item;
        const dataTemp = data.map((v) => ({ ...v, value: v.value || '' }));
        const serie = {
          type: 'pie',
          minAngle: 25,
          radius: this.isRing ? ['50', '70'] : ['0', '70'],
          center: ['50%', '102'],
          label: {
            show: this.hasPieLabel,
            formatter: '{b} {c} ({d}%)',
            fontSize: 12,
            color: '#455A74',
          },
          itemStyle: {
            borderColor: '#FFFFFF',
            borderWidth: 1,
          },
          ...item,
          data: dataTemp,
        };
        this.option.series.push(serie);
      });
      this.chartsDom.setOption(this.option);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PieChart.vue